module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/kyiv-dnipro-holovnyi-a427a7ff26776da2a9589ce977763eba.png";